import { Controller } from "@hotwired/stimulus"

// Tiny per-row helper for the Circle of Support list. Each row in the
// editor shows [icon] [name input] [relationship select] [remove]; the
// icon is decorative and reflects the currently-selected category.
//
// The dynamic-list controller already binds the row's data; this
// controller only watches the relationship <select> and rewrites the
// `data-lucide` attribute on the adjacent icon span so the glyph stays
// in sync with whatever the user picks (Family / Friend / Professional /
// Community / Service Dog / TBD).

const ICON_FOR_RELATIONSHIP = {
  "Family":       "users",
  "Friend":       "smile",
  "Professional": "briefcase",
  "Community":    "globe",
  "Service Dog":  "dog",
  "TBD":          "help-circle"
}

export default class extends Controller {
  static targets = ["icon", "select"]

  connect() {
    this._refresh()
  }

  // Wired via data-action="change->cos-relationship#update" on the
  // <select>. Also re-fires whenever dynamic-list sets the row's
  // initial value programmatically (via input events).
  update() {
    this._refresh()
  }

  _refresh() {
    if (!this.hasIconTarget) return
    const sel = this.hasSelectTarget
      ? this.selectTarget
      : this.element.querySelector("select[data-field='relationship']")
    const val = sel ? sel.value : ""
    const lucide = ICON_FOR_RELATIONSHIP[val] || "user"
    // Rebuild the inner <i> so lucide picks it up on the next createIcons.
    this.iconTarget.innerHTML = `<i data-lucide="${lucide}"></i>`
    if (window.lucide && typeof window.lucide.createIcons === "function") {
      window.lucide.createIcons({ nameAttr: "data-lucide" })
    }
  }
}
